import styled from "@emotion/styled";
export const StyledDirectoryTemplate = styled.div`
  .directory-component-wrapper {
    background-color: #f5f5f5;
    padding-top: 64px;
  }
`;
